import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

function SpeechModelsTable({ models, onEdit, onDelete }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>STT Service Provider</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {models.map(model => (
                <ModelRow model={model} key={model.id} onEdit={onEdit} onDelete={onDelete} />
            ))}
            </tbody>
        </table>
    );
}

function ModelRow({ model, onEdit, onDelete }) {
    return (
        <tr>
            <td>{model.id}</td>
            <td>{model.name}</td>
            <td>{model.sttServiceProvider}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(model)}/>
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(model.id)}/>
            </td>
        </tr>
    );
}

export default SpeechModelsTable;
